import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import './index.scss'
const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Calendario y horarios del Mundial de Rusia 2018, lista completa del Calendario"
      meta={[
        { name: 'description', content: 'Calendario completo de los partidos de la fase de grupos del Mundial de Rusia. Conoce las fechas y horarios de los encuentros del sorteo del Mundial 2018.' },
        { name: 'keywords', content: 'Calendario, Grupos, Calendario Mundial, Calendario Mundial Rusia, Calendario Mundial Rusia 2018, Calendario Completo Mundial, Mundial, Mundial de Rusia, Mundial de Rusia 2018, Partidos Mundial, Grupos Mundial, Grupos Mundial 2018, Sorteo Mundial Rusia' },
      ]}
    ></Helmet>
    {children()}
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js